import './index.css';

import React from 'react';
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from 'react-router-dom';

import { App } from './App';
import { DYNAMIC_PAGE_PATHS } from './components/views/DynamicPageView/config/shared/pathRoutes';
import { DynamicPageView } from './components/views/DynamicPageView/DynamicPageView';
import { NotFoundView } from './components/views/NotFoundView';

export const paths = {
  App: '/',
  AccountView: '/account',
  FunnelView: '/funnel',
};

export const publicPaths = ['/reset-password', '/forgot-password'];

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path={paths.App} element={<App currentPath={location.pathname} />}>
      {Object.keys(DYNAMIC_PAGE_PATHS).map((key) => (
        <Route
          path={DYNAMIC_PAGE_PATHS[key]}
          key={key}
          element={<DynamicPageView key={key} path={DYNAMIC_PAGE_PATHS[key]} />} //key is needed here in order to force the unmount of DynamicPageView on path change
        />
      ))}
      <Route path={'*'} element={<NotFoundView />} />
    </Route>,
  ),
);

export function Routes() {
  return <RouterProvider router={router} />;
}
